import React from "react";
import { IconButton, TableCell } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { getPhoneIconByEstado } from "../ListadoSolicitud.iconMaps";

// Columna "Telefonica": ícono según idEstadoVerificacionTelefonica.
export default function CeldaTelefonica({
  data,
  isError,
  estaDeshabilitado,
  verificacionSolicitud,
  estadoDeshabilitadotelefonica,
  handleTelefonica,
  handlePopoverOpen,
}) {
  return (
    <TableCell align="center">
      <div>
        <span>
          <IconButton
            onClick={() => handleTelefonica(data)}
            disabled={
              data.idEstadoVerificacionTelefonica === 1 ||
              estaDeshabilitado(data) ||
              verificacionSolicitud(data) ||
              estadoDeshabilitadotelefonica(data)
            }
            size="small"
            sx={{
              opacity: estaDeshabilitado(data) ? 0.4 : 1,
              bgcolor: isError ? "#fee2e2" : "#f1f5f9",
              "&:hover": {
                bgcolor: isError ? "#fca5a5" : "#e2e8f0",
                transform: "scale(1.1)",
              },
              transition: "all 0.2s ease",
            }}
          >
            {getPhoneIconByEstado(
              data.idEstadoVerificacionTelefonica
            )}
          </IconButton>
          {/* InfoIcon al lado del IconButton */}
          <span
            style={{
              // pointerEvents: estaDeshabilitado(data)
              //   ? "none"
              //   : "auto",
              // opacity: estaDeshabilitado(data) ? 0.5 : 1,
            }}
          >
            <MoreVertIcon
              onClick={(event) =>
                handlePopoverOpen(event, 2, data)
              }
              style={{ cursor: "pointer" }}
            />
          </span>
        </span>

      </div>
    </TableCell>
  );
}
